import EssDocsSSORoute from './EssdocsSSORoute'

const routes = [
    new EssDocsSSORoute()
]

export default routes